import type { AssetAssessment, AssessmentAction } from "./types";

export interface VerifyFormState {
  verdict: string;
  certRef: string;
  notes: string;
  // detailed assessment
  damageMechanisms: string;
  summary: string;
  corrosionBasis: string;
  intervalBasis: string;
  ffsRequired: boolean;
  ffsNote: string;
  actions: AssessmentAction[];
  confidence: string;
}

export function emptyForm(): VerifyFormState {
  return {
    verdict: "", certRef: "", notes: "",
    damageMechanisms: "", summary: "", corrosionBasis: "", intervalBasis: "",
    ffsRequired: false, ffsNote: "", actions: [], confidence: "",
  };
}

export interface VerifyBody {
  verdict: string;
  expert_notes: string;
  cert_ref: string;
  assessment?: AssetAssessment;
}

function nonBlankActions(rows: AssessmentAction[]): AssessmentAction[] {
  return rows.filter((r) => r.action.trim() !== "" || r.due.trim() !== "");
}

function hasDetail(f: VerifyFormState): boolean {
  const actions = nonBlankActions(f.actions);
  return (
    f.damageMechanisms.trim() !== "" || f.summary.trim() !== "" ||
    f.corrosionBasis.trim() !== "" || f.intervalBasis.trim() !== "" ||
    f.confidence.trim() !== "" || f.ffsRequired || f.ffsNote.trim() !== "" ||
    actions.length > 0
  );
}

/** Map form state to the /review/verify request body. `assessment` is omitted
 *  entirely when no detailed field was filled (a bare verdict sign-off). */
export function buildVerifyBody(f: VerifyFormState): VerifyBody {
  const body: VerifyBody = {
    verdict: f.verdict.trim(),
    expert_notes: f.notes,
    cert_ref: f.certRef.trim(),
  };
  if (hasDetail(f)) {
    body.assessment = {
      damage_mechanisms: f.damageMechanisms,
      summary: f.summary,
      corrosion_basis: f.corrosionBasis,
      interval_basis: f.intervalBasis,
      ffs: { required: f.ffsRequired, note: f.ffsNote },
      actions: nonBlankActions(f.actions),
      confidence: f.confidence,
    };
  }
  return body;
}
